import { MeshNormalMaterial, MeshNormalMaterialParameters } from '../../thirdparty/three/imports';
import { Material3D } from './Material3D';

export interface MeshNormalMaterial3D
{
    get _material(): MeshNormalMaterial;
    set _material(v: MeshNormalMaterial);
}

export class MeshNormalMaterial3D extends Material3D
{
    constructor(parameters?: MeshNormalMaterialParameters)
    {
        super();
        this._material = new MeshNormalMaterial(parameters);
    }

    destroy()
    {
        super.destroy();
    }
}
